module.exports = __webpack_public_path__ + "img/logo.1d8bc838.jpg";